import { LOUNGE_CHANNEL_ID } from '@onr/schema'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'

import { type TeamConversationViewProps } from '@/components/templates/TeamConversationView'
import { regionQuery } from '@/state/regions/region'
import { dashboardRegionTeamQuery } from '@/state/teams/teams'

import { teamCarType } from '../dashboard/data/teamCar'

import { teamStatus } from './teamStatus'
import { useMessagingRail } from './useMessagingRail'

export const useTeamMessagesWithoutTeamPage = (): TeamConversationViewProps => {
  const { regionId } = useParams({ from: '/dashboard/$regionId' })
  const region = useSuspenseQuery(regionQuery(regionId))
  const teams = useSuspenseQuery(dashboardRegionTeamQuery(region.data.data))

  const teamItems = teams.data.data.map((team) => ({
    ...team,
    teamId: team._id,
    hasUnreadMessages: team.messagingStatus.hasUnreadAdminMessages,
    carNumber: String(team.number ?? '?'),
    carType: teamCarType(team.vehicle),
    state: teamStatus(team),
  }))

  const rail = useMessagingRail({
    regionId,
    eveningId: region.data.data?.currentOperatingDate?.eveningId,
    teamsHaveUnread: teamItems.some((team) => team.hasUnreadMessages),
    destination: 'teams',
    teamsTo: '/dashboard/$regionId/messages',
    teamsParams: { regionId },
    channelId: LOUNGE_CHANNEL_ID,
    channelTo: '/dashboard/$regionId/messages/channels/$channelId',
    channelParams: { regionId, channelId: LOUNGE_CHANNEL_ID },
  })

  return {
    rail,
    messages: [],
    teams: teamItems,
    regionName: region.data.data?.name ?? '',
    piloteRegionId: region.data.data?.piloteId ?? 0,
  }
}
